export default "__VITE_ASSET__DQI0oY1N__"